export const table_title_accumulated_precp = ['縣市', '鄉鎮', '雨量站', '累積雨量(mm)', '累積時數(小時)'];

export const town_list_file = '/static/common/town_list/taiwan_town.json';